module.exports = __webpack_public_path__ + "img/2D-2BHK-t3.cd7474c0.png";